import { createSlice } from "@reduxjs/toolkit";
import { getAllAdminRoles, getAllAdminUsers } from "./UserManagementActions";
import { IUserManagementSlice } from "../../models/admin/userManagement/userManagement";

const initialState: IUserManagementSlice = {
  adminUsers: [],
  adminRoles: [],
};

const userManagementSlice = createSlice({
  name: "userManagement",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllAdminUsers.fulfilled, (state, { payload }) => {
      state.adminUsers = payload.data || [];
    });
    builder.addCase(getAllAdminRoles.fulfilled, (state, { payload }) => {
      state.adminRoles = payload.data || [];
    });
  },
});

export default userManagementSlice.reducer;
